import React, { Component } from "react";
import AvatarEditor from "react-avatar-editor";
import Button from "react-bootstrap-button-loader";
import Dropzone from "react-dropzone";
import LocaleStrings from "Languages";
var Loader = require("react-loaders").Loader;
export default class ImageCropper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canvasRecource: props.canvasRecource,
      imagePreviewUrl: props.imagePreviewUrl,
      coverImagePreviewUrl: props.coverImagePreviewUrl,
      imagepath: props.imagepath,
      imageErrorClsName: "alert-danger",
      imageErrorMsg: "",
      minScale: 1,
      maxScale: 1.2,
      scaleStep: 0.05,
      scale: 1,
      defaultScale: 1,
      fileLoading: false,
    };

    this.setEditorRef = this.setEditorRef.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
    this.resetImage = this.resetImage.bind(this);
    this.onDropFile = this.onDropFile.bind(this);
  }

  // This function is added by vinay as it requires in course cover image display on 29/12/2020. I have tested others component where this component is import, not any issue found. if in future any issue occures then need to change this function.
  componentWillReceiveProps(nextProps) {
    if (nextProps) {
      if (nextProps.imagepath !== "" && this.state.imagepath === "") {
        this.setState({ imagepath: nextProps.imagepath });
      }
    }
  }

  setEditorRef = (editor) => (this.editor = editor);

  onClickSave = () => {
    this.saveImage(null);
  };

  saveImage = (callback) => {
    if (this.editor) {
      var imageType = this.props.imageType;
      if (!imageType) imageType = "jpg";

      var img;
      if (imageType === "png") img = this.editor.getImage().toDataURL();
      else img = this.editor.getImage().toDataURL("image/jpeg", 0.9);
      //console.log("img", img);
      this.setState({ imagepath: img });
      this.props.onImageSave(img);
      if (callback) {
        setTimeout(() => {
          callback();
        }, 2000);
      }
    }
  };

  resetImage = () => {
    this.setState({
      canvasRecource: "",
      imagepath: "",
      scale: this.state.defaultScale,
      imageErrorMsg: "",
    });
    this.props.onImageSave("");
    this.props.onImageChange(false);
  };

  onDropFile = (files) => {
    let { requiredSize } = this.props;
    let file = files[0];
    let requiredWidth = requiredSize.width;
    let requiredHeight = requiredSize.height;
    let that = this;
    that.setState({ fileLoading: true });
    let reader = new FileReader();
    if (file && file.type.indexOf("image") != -1) {
      reader.onload = (e) => {
        let img = new Image();
        img.src = reader.result;

        img.onload = function () {
          let width = this.width;
          let height = this.height;

          if (width < requiredWidth || height < requiredHeight) {
            that.setState({
              fileLoading: false,
              imageErrorMsg:
                "Image is smaller than recommended image, upload another image.!",
            });
            that.props.onImageChange(false);
          } else {
            that.setState({
              ...this.state,
              canvasRecource: reader.result,
              imageErrorMsg: "",
              fileLoading: false,
            });
            that.props.onImageChange(true);
          }
        };
        // this.props.onImageChange(true);
      };
      reader.readAsDataURL(file);
    }
  };

  onZoomOut() {
    var scale = this.state.scale;
    scale = scale - this.state.scaleStep;
    if (scale < this.state.minScale) scale = this.state.minScale;
    this.setState({ ...this.state, scale });
  }

  onZoomIn() {
    var scale = this.state.scale;
    scale = scale + this.state.scaleStep;
    if (scale > this.state.maxScale) scale = this.state.maxScale;
    this.setState({ ...this.state, scale });
  }

  render() {
    let {
      className,
      displaySize,
      cropperSize,
      insideImage,
      insideImageStyle,
      insideText,
      border,
    } = this.props;
    let imageUrl = this.state.imagepath;
    var hideDropZoneClass = "";
    var hideCropZineClass = "hide-feature";
    var hideControlButton = "hide-feature";
    var imageDisplayContaner = {
      width: displaySize.width,
      height: displaySize.height,
    };

    if (imageUrl && imageUrl !== "file object not found") {
      hideDropZoneClass = "hide-feature";
      hideCropZineClass = "hide-feature";
      hideControlButton = "";
    }

    if (this.state.canvasRecource && !imageUrl) {
      hideDropZoneClass = "hide-feature";
      hideCropZineClass = "";
      imageDisplayContaner = {
        width: displaySize.width,
        height: displaySize.height,
        marginBottom: this.props.marginBottom ? this.props.marginBottom : 10,
      };
    }
    if (this.state.imageErrorMsg != "") {
      hideControlButton = "";
      hideDropZoneClass = "hide-feature";
    }

    var imageErrorStyle = {
      padding: "5px",
      margin: "5px 0px",
    };
    //console.log("imageUrl", imageUrl);
    return (
      <div>
        <div className="position-relative" style={imageDisplayContaner}>
          <Dropzone
            //onDrop={(e) => this.onDrop(e)}
            onDrop={this.onDropFile}
            accept="image/*"
            multiple={false}
          >
            {({ getRootProps, getInputProps }) => (
              <div
                {...getRootProps()}
                className={`${className} ${hideDropZoneClass} h-full w-full`}
              >
                <div>
                  <input {...getInputProps()} />
                  <img src={insideImage} style={insideImageStyle} />
                  <div className="drag-drop-text">{insideText}</div>
                  {this.state.fileLoading ? (
                    <Loader
                      type="line-scale-pulse-out-rapid"
                      active
                      className="loader-div"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}
          </Dropzone>

          {this.state.imageErrorMsg && this.state.imageErrorMsg != "" ? (
            <div
              className={this.state.imageErrorClsName}
              style={imageErrorStyle}
            >
              {this.state.imageErrorMsg}
            </div>
          ) : (
            <div>
              <img
                src={imageUrl}
                alt=""
                className={`img-responsive w-100 ${hideControlButton}`}
              />
              <div className={hideCropZineClass}>
                <AvatarEditor
                  image={this.state.canvasRecource}
                  color={[0, 0, 0, 0.5]} // RGBA
                  scale={this.state.scale}
                  rotate={0}
                  ref={this.setEditorRef}
                  disabledrop="true"
                  border={border ? border : 50}
                  width={cropperSize.width}
                  height={cropperSize.height}
                  className="editor-canvas"
                  style={{ background: "#777" }}
                />
              </div>
            </div>
          )}

          <div
            className={`cropper-remove-button-position ${hideControlButton}`}
          >
            <Button
              type="button"
              className={`btn-custom-default-sm`}
              onClick={this.resetImage}
            >
              {" "}
              {LocaleStrings.button_remove}{" "}
            </Button>
          </div>
        </div>

        <div className={`dropzone-control-button ${hideCropZineClass}`}>
          <Button
            type="button"
            className="btn i-custom-blue"
            onClick={this.onZoomIn.bind(this)}
          >
            <i className="fa fa-search-plus"></i>
          </Button>
          <Button
            type="button"
            className="btn i-custom-blue"
            onClick={this.onZoomOut.bind(this)}
          >
            <i className="fa fa-search-minus"></i>
          </Button>
          <Button
            type="button"
            className="btn btn-custom-blue"
            onClick={this.onClickSave}
          >
            {LocaleStrings.button_crop_save}
          </Button>
          <Button
            type="button"
            className="btn i-custom-red"
            onClick={this.resetImage}
          >
            <img
              className="i-custom-normal"
              src="../../style/images/custom-icons/shape-1317-copy-3.svg"
            />
          </Button>
        </div>
      </div>
    );
  }
}
